<template>
  <div dir="rtl" ref="content">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>

    <v-icon
      v-if="permissions.fatworas_print == 1 || user.type == 1"
      @click="print"
      >print</v-icon
    >

    <div
      id="printMe"
      style="width:800px;max-width:800px;direction:rtl;text-align: right;margin:auto"
    >
      <div
        style="-webkit-box-flex: 1;-ms-flex: 1 1 100%;flex: 1 1 100%;margin: auto;padding: 24px;width: 800px;max-width: 800px;direction: rtl;text-align: right;padding:15px"
      >
        <div
          style="flex-wrap: wrap;direction: rtl;display: flex;-webkit-box-flex: 1;padding-bottom:30px;"
        >
          <div
            style="position: relative;height: 120px;flex-wrap: wrap;flex-basis: 800px;-webkit-box-flex: 1;flex-grow: 0;max-width: 800px;padding:5px;direction: rtl;"
          >
            <div
              style="position: absolute;right: 89px;top: 34px;font-size: 20px;width: 370px;flex-basis: 390px;-webkit-box-flex: 0;flex-grow: 0;max-width: 390px;direction: rtl;text-align:center;"
            >
              <span style="font-wight:bold;color:orange;font-size: 30px;"
                >Accurate</span
              >
              For Medical Industries
            </div>
            <div
              style="position: absolute;left: 13px;top: 0px;display:inline-block;width: 360px;flex-basis: 390px;-webkit-box-flex: 0;flex-grow: 0;max-width: 390px;direction: rtl;text-align:center;"
            >
              <img
                style="width:200px;height:110px;direction: rtl;"
                src="../../../public/images/color.png"
                alt=""
              />
            </div>
            <br />
            <hr style="width:100%;position: absolute;bottom: 0px;" />
          </div>

          <div
            style="flex-basis: 30%;-webkit-box-flex: 0;flex-grow: 0;max-width: 30%;padding:5px;direction: rtl;"
          >
            <p style="font-size: 30px;font-weight:bold;margin:0px">
              {{ fatwora.client ? fatwora.client.name : "" }}
            </p>
            <p style="margin:0px">
              <b>كود العميل : </b>
              {{ fatwora.client ? fatwora.client.code : "" }}
            </p>
            <p style="margin:0px">
              <b>عنوان العميل : </b>
              {{ fatwora.client ? fatwora.client.address : "" }}
            </p>
            <p style="margin:0px">
              <b>المديونية السابقة : </b> {{ fatwora.madionia_sabqa }}
            </p>
            <p style="margin:0px">
              <b>المديونية الحالية : </b> {{ fatwora.madionia_now }}
            </p>
          </div>
          <div
            style="flex-basis: 30%;-webkit-box-flex: 0;flex-grow: 0;max-width: 30%;text-align:center;direction: rtl;"
          >
            <p style="margin:0px"><b>إذن صرف رقم : </b> {{ fatwora.code }}</p>
            <p style="margin:0px">
              <b> الرصيد الافتتاحي : </b
              >{{ fatwora.client ? fatwora.client.rasid_efttahi : "" }}
            </p>
            <p style="margin:0px">
              <b> الحد الائتماني : </b
              >{{ fatwora.client ? fatwora.client.had_eetmani : "" }}
            </p>
          </div>
          <div
            style="flex-basis: 30%;-webkit-box-flex: 0;flex-grow: 0;max-width: 30%;direction: rtl;text-align:center;"
          >
            <p style="margin:0px">
              <b>تاريخ الفاتورة : </b> {{ fatwora.created_at }}
            </p>
            <p style="margin:0px">
              <b>مندوب المبيعات : </b>
              {{
                fatwora.client && fatwora.client.mandob_sales
                  ? fatwora.client.mandob_sales.name
                  : ""
              }}
            </p>
            <p style="margin:0px">
              <b>مندوب التوزيع : </b>
              {{
                fatwora.client && fatwora.mandob_tawzi3
                  ? fatwora.mandob_tawzi3.name
                  : ""
              }}
            </p>
          </div>
        </div>
        <hr style="width:100%" />
        <hr style="width:100%" />

        <div
          style="flex-wrap: wrap;direction: rtl;display: flex;-webkit-box-flex: 1;width: 800px;max-width: 800px;"
        >
          <div
            style="flex-wrap: wrap;display: flex;-webkit-box-flex: 1;flex-basis: 100%;-webkit-box-flex: 0;flex-grow: 0;width: 800px;max-width: 800px;direction: rtl;text-align:center;border-bottom:2px solid;"
          >
            <p
              style="flex-basis: 18%;-webkit-box-flex: 0;flex-grow: 0;max-width:18%;direction: rtl;text-align:center;margin:0px;padding:8px;border-left:2px dotted;font-weight:bold;"
            >
              الصنف
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width:8%;direction: rtl;text-align:center;margin:0px;padding:8px;border-left:2px dotted;font-weight:bold;"
            >
              سعر الوحدة
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width:8%;direction: rtl;text-align:center;margin:0px;padding:8px;border-left:2px dotted;font-weight:bold;"
            >
              العدد
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width:8%;direction: rtl;text-align:center;margin:0px;padding:8px;border-left:2px dotted;font-weight:bold;"
            >
              البونص
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width:8%;direction: rtl;text-align:center;margin:0px;padding:8px;border-left:2px dotted;font-weight:bold;"
            >
              العدد النهائي
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width:8%;direction: rtl;text-align:center;margin:0px;padding:8px;border-left:2px dotted;font-weight:bold;"
            >
              الخصم للصنف
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width:8%;direction: rtl;text-align:center;margin:0px;padding:8px;font-weight:bold;"
            >
              السعر الكلي للصنف
            </p>
          </div>

          <div
            v-for="(f, i) in fatwora.fatwora_items"
            :key="i"
            :style="[
              i % 2 == 0
                ? { 'background-color': '#ccc' }
                : { 'background-color': '#fff' }
            ]"
            style="flex-wrap: wrap;display: flex;-webkit-box-flex: 1;flex-basis: 100%;-webkit-box-flex: 0;flex-grow: 0;width: 800px;max-width: 800px;direction: rtl;text-align:center;border-bottom:2px solid;"
          >
            <p
              style="flex-basis: 18%;-webkit-box-flex: 0;flex-grow: 0;max-width:18%;direction: rtl;text-align:center;margin:0px;padding:8px;border-left:2px dotted;font-weight:bold;"
            >
              {{ f.item_name }}
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width:8%;direction: rtl;text-align:center;margin:0px;padding:8px;border-left:2px dotted;"
            >
              {{ f.price }}
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width:8%;direction: rtl;text-align:center;margin:0px;padding:8px;border-left:2px dotted;"
            >
              {{ f.item_num }}
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width:8%;direction: rtl;text-align:center;margin:0px;padding:8px;border-left:2px dotted;"
            >
              {{ f.item_bonus }}
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width:8%;direction: rtl;text-align:center;margin:0px;padding:8px;border-left:2px dotted;"
            >
              {{ f.item_num_after }}
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width:8%;direction: rtl;text-align:center;margin:0px;padding:8px;border-left:2px dotted;"
            >
              {{ f.item_discount }}
            </p>
            <p
              style="flex-basis: 8%;-webkit-box-flex: 0;flex-grow: 0;max-width:8%;direction: rtl;text-align:center;margin:0px;padding:8px"
            >
              {{ f.final_price }}
            </p>
          </div>
          <hr style="width:100%" />
          <hr style="width:100%" />
        </div>

        <div
          style="background-color:#CCCDF9;flex-wrap: wrap;direction: rtl;display: flex;-webkit-box-flex: 1;width: 800px;max-width: 800px;"
        >
          <p
            style="flex-basis: 20%;-webkit-box-flex: 0;flex-grow: 0;max-width:20%;direction: rtl;text-align:center;margin:0px;padding:8px;border-left:2px dotted;font-weight:bold;"
          >
            اجمالي الفاتورة
          </p>
          <p
            style="flex-basis: 20%;-webkit-box-flex: 0;flex-grow: 0;max-width:20%;direction: rtl;text-align:center;margin:0px;padding:8px;border-left:2px dotted;font-weight:bold;"
          >
            الخصم
          </p>
          <p
            style="flex-basis: 20%;-webkit-box-flex: 0;flex-grow: 0;max-width:20%;direction: rtl;text-align:center;margin:0px;padding:8px;border-left:2px dotted;font-weight:bold;"
          >
            صافي الفاتورة
          </p>
        </div>
        <div
          style="background-color:#CCCDF9;flex-wrap: wrap;display: flex;-webkit-box-flex: 1;flex-basis: 100%;-webkit-box-flex: 0;flex-grow: 0;width: 800px;max-width: 800px;direction: rtl;text-align:center;border-bottom:2px solid;"
        >
          <p
            style="flex-basis: 20%;-webkit-box-flex: 0;flex-grow: 0;max-width:20%;direction: rtl;text-align:center;margin:0px;padding:8px;border-left:2px dotted;font-weight:bold;"
          >
            {{ fatwora.price_before }}
          </p>
          <p
            style="flex-basis: 20%;-webkit-box-flex: 0;flex-grow: 0;max-width:20%;direction: rtl;text-align:center;margin:0px;padding:8px;border-left:2px dotted;"
          >
            {{ fatwora.discount }}
          </p>
          <p
            style="flex-basis: 20%;-webkit-box-flex: 0;flex-grow: 0;max-width:20%;direction: rtl;text-align:center;margin:0px;padding:8px;border-left:2px dotted;"
          >
            {{ fatwora.price_after }}
          </p>
        </div>

        {{ user.name }}
      </div>
    </div>
  </div>
</template>

<script>
import { fatwora_detail } from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],

    search: "",
    loading: true,

    fatwora: [],
    title: ""
  }),

  computed: {},

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    let id = this.$route.params.fatwora_id;
    var frmData = new FormData();
    fatwora_detail(id, frmData).then(response => {
      this.fatwora = response.data;
      this.loading = false;
    });
  },

  methods: {
    // download(){
    //     const doc = new jsPDF();
    //       const contentHtml = this.$refs.content.innerHTML;
    //       doc.fromHTML(contentHtml, 15, 15, {
    //         width: 170
    //       });
    //       doc.save("sample.pdf");
    //     },
    //  downloadWithCSS() {
    //           const doc = new jsPDF();
    //           /** WITH CSS */
    //           var canvasElement = document.createElement('canvas');
    //             html2canvas(this.$refs.content, { canvas: canvasElement
    //               }).then(function (canvas) {
    //             const img = canvas.toDataURL("image/jpeg", 0.8);
    //             doc.addImage(img,'JPEG',20,20);
    //             doc.save("sample.pdf");
    //           });
    //   },

    print() {
      // this.$htmlToPaper('printMe');

      var title = document.title;
      var divElements = document.getElementById("printMe").innerHTML;
      var printWindow = window.open("", "_blank", "");
      //open the window
      printWindow.document.open();
      //write the html to the new window, link to css file
      printWindow.document.write(
        "<html><head><title>" +
          title +
          '</title><link rel="stylesheet" type="text/css" href="/Css/site-print.css"></head><body>'
      );
      printWindow.document.write(divElements);
      printWindow.document.write("</body></html>");
      printWindow.document.close();
      printWindow.focus();
      //The Timeout is ONLY to make Safari work, but it still works with FF, IE & Chrome.
      setTimeout(function() {
        printWindow.print();
        printWindow.close();
      }, 100);
    }
  }
};
</script>
